import React from 'react';

const SettingsContent = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Account Settings</h2>
      <div className="bg-white rounded-lg shadow divide-y">
        <GeneralSettings />
        <AccountInformation />
      </div>
    </div>
  );
};

const GeneralSettings = () => {
  const settings = [
    { name: 'Enable notifications', defaultChecked: true },
    { name: 'Dark mode', defaultChecked: false },
    { name: 'Two-factor authentication', defaultChecked: false },
  ];

  return (
    <div className="p-4">
      <h3 className="font-medium">General Settings</h3>
      <div className="mt-4 space-y-4">
        {settings.map((setting) => (
          <SettingToggle 
            key={setting.name} 
            name={setting.name} 
            defaultChecked={setting.defaultChecked} 
          />
        ))}
      </div>
    </div>
  );
};

const SettingToggle = ({ name, defaultChecked }) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <span>{name}</span>
      <input type="checkbox" className="h-4 w-4" defaultChecked={defaultChecked} />
    </div>
  );
};

const AccountInformation = () => {
  const fields = [
    { label: 'Email', value: 'user@example.com', type: 'email' },
    { label: 'Organization', value: 'Example Corp', type: 'text' },
  ];

  return (
    <div className="p-4">
      <h3 className="font-medium">Account Information</h3>
      <div className="mt-4 space-y-4">
        {fields.map((field) => (
          <FormField 
            key={field.label} 
            label={field.label} 
            value={field.value} 
            type={field.type} 
          />
        ))}
      </div>
    </div>
  );
};

const FormField = ({ label, value, type }) => {
  return (
    <div>
      <label className="block text-sm text-gray-500">{label}</label>
      <input
        type={type}
        className="mt-1 p-2 border rounded w-full"
        value={value}
        readOnly
      />
    </div>
  );
};

export default SettingsContent;